<template>
    <div class="principale" v-if="loggedInEmail">
      
       <header>
          <div class="container">
            <div class="menu">
              <RouterLink to="/"><img class="logo" alt="Vue logo" src="./assets/logo.png"></RouterLink>

              <nav>
                <div class="maj">
                  <p>Bonjour {{ loggedInPrenom }} {{ loggedInNom }}</p>
                  {{ maj }}
                </div>
                <ul>
                  <li v-if="loggedInRole !== 'reception' && loggedInRole !== 'approvisionnement' && loggedInRole !== 'comptabilite'"><RouterLink to="/"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-check-fill" viewBox="0 0 16 16">
                    <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm1.354 4.354-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708.708z"/>
                  </svg>Articles</RouterLink></li>
                  <li v-if="loggedInRole === 'achats' || loggedInRole === 'admin' || loggedInRole === 'production' || loggedInRole === 'be' || loggedInRole=='gestion'"><RouterLink to="/affaires"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-bar-graph-fill" viewBox="0 0 16 16">
                    <path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-2 11.5v-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm-2.5.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1zm-3 0a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-1z"/>
                  </svg>Affaires</RouterLink></li>
                  <li v-if="loggedInRole === 'achats' || loggedInRole === 'admin' || loggedInRole === 'production' || loggedInRole === 'be' || loggedInRole=='gestion'"><RouterLink to="/evol-affaires"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-bar-graph-fill" viewBox="0 0 16 16">
                    <path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-2 11.5v-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm-2.5.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1zm-3 0a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-1z"/>
                  </svg>Évol affaires</RouterLink></li>
                  <li v-if="loggedInRole === 'achats' || loggedInRole === 'admin' || loggedInRole === 'gestion'"><RouterLink to="/demandes"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chat-quote-fill" viewBox="0 0 16 16">
                    <path d="M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7zM7.194 6.766a1.688 1.688 0 0 0-.227-.272 1.467 1.467 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 5.734 6C4.776 6 4 6.746 4 7.667c0 .92.776 1.666 1.734 1.666.343 0 .662-.095.931-.26-.137.389-.39.804-.81 1.22a.405.405 0 0 0 .011.59c.173.16.447.155.614-.01 1.334-1.329 1.37-2.758.941-3.706a2.461 2.461 0 0 0-.227-.4zM11 9.073c-.136.389-.39.804-.81 1.22a.405.405 0 0 0 .012.59c.172.16.446.155.613-.01 1.334-1.329 1.37-2.758.942-3.706a2.466 2.466 0 0 0-.228-.4 1.686 1.686 0 0 0-.227-.273 1.466 1.466 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 10.07 6c-.957 0-1.734.746-1.734 1.667 0 .92.777 1.666 1.734 1.666.343 0 .662-.095.931-.26z"/>
                  </svg>Demandes</RouterLink></li>
                  <li v-if="loggedInRole === 'achats' || loggedInRole === 'admin' || loggedInRole=='gestion'"><RouterLink to="/achats"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chat-quote-fill" viewBox="0 0 16 16">
                    <path d="M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7zM7.194 6.766a1.688 1.688 0 0 0-.227-.272 1.467 1.467 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 5.734 6C4.776 6 4 6.746 4 7.667c0 .92.776 1.666 1.734 1.666.343 0 .662-.095.931-.26-.137.389-.39.804-.81 1.22a.405.405 0 0 0 .011.59c.173.16.447.155.614-.01 1.334-1.329 1.37-2.758.941-3.706a2.461 2.461 0 0 0-.227-.4zM11 9.073c-.136.389-.39.804-.81 1.22a.405.405 0 0 0 .012.59c.172.16.446.155.613-.01 1.334-1.329 1.37-2.758.942-3.706a2.466 2.466 0 0 0-.228-.4 1.686 1.686 0 0 0-.227-.273 1.466 1.466 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 10.07 6c-.957 0-1.734.746-1.734 1.667 0 .92.777 1.666 1.734 1.666.343 0 .662-.095.931-.26z"/>
                  </svg>Achats</RouterLink></li>
                  <li v-if="loggedInRole=='admin'"><RouterLink to="/utilisateurs"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-people-fill" viewBox="0 0 16 16">
                    <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216ZM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/>
                  </svg>Utilisateurs</RouterLink></li>
                  <li v-if="loggedInRole=='admin' || loggedInRole=='gestion'"><RouterLink to="/recap"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-people-fill" viewBox="0 0 16 16">
                    <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216ZM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/>
                  </svg>Recaps</RouterLink></li>
                    <li v-if="loggedInRole=='admin' || loggedInRole=='gestion' || loggedInRole === 'production'"><RouterLink to="/inventaire"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-people-fill" viewBox="0 0 16 16">
                    <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216ZM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/>
                  </svg>Inventaire</RouterLink></li>
                  <li v-if="loggedInRole === 'production'"><RouterLink to="/mes-heures"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clock-history" viewBox="0 0 16 16"><path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z"/><path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z"/><path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z"/></svg>Heures</RouterLink></li>
                  <li v-if="loggedInRole === 'admin' || loggedInRole === 'production' || loggedInRole === 'be' || loggedInRole === 'gestion' || loggedInRole === 'comptabilite'"><RouterLink to="/scan-documents"><svg fill="#ffffff" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M8,2A1,1,0,0,1,8,4H4V8A1,1,0,0,1,2,8V3A1,1,0,0,1,3,2ZM8,20H4V16a1,1,0,0,0-2,0v5a1,1,0,0,0,1,1H8a1,1,0,0,0,0-2Zm13-5a1,1,0,0,0-1,1v4H16a1,1,0,0,0,0,2h5a1,1,0,0,0,1-1V16A1,1,0,0,0,21,15Zm0-6a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H16a1,1,0,0,0,0,2h4V8A1,1,0,0,0,21,9Zm1,2H2a1,1,0,0,0,0,2H22a1,1,0,0,0,0-2Z"></path></g></svg>GED</RouterLink></li>
                  <li v-if="loggedInRole=='admin'"><RouterLink to="/admin"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-people-fill" viewBox="0 0 16 16">
                    <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216ZM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/>
                  </svg>Outils</RouterLink></li>
                
                  <li class="deco" @click="logout()"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-arrow-left" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0z"/>
                    <path fill-rule="evenodd" d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708z"/>
                  </svg></li>
                </ul>
              </nav>
              
              <!-- Menu hamburger mobile -->
              <div class="mobile-menu-toggle" @click="toggleMobileMenu">
                <span></span>
                <span></span>
                <span></span>
              </div>
              
            </div>

          </div>
         
        </header>
        <div class="sous-menu">
          <img src="./assets/simef-bg.jpg" alt="">
          <div class="container links"><a href="https://www.simef.fr/outils-internes/">Nos outils internes</a></div>
        </div>
        <main class="main">
            <router-view/>
        </main>
        
        <!-- Menu mobile overlay -->
        <div class="mobile-menu-overlay" :class="{ 'active': isMobileMenuOpen }" @click="closeMobileMenu">
          <div class="mobile-menu-content" @click.stop>
            <div class="mobile-menu-header">
              <h3>Menu</h3>
              <button class="close-menu" @click="closeMobileMenu">×</button>
            </div>
            <div class="mobile-menu-user">
              <p>Bonjour {{ loggedInPrenom }} {{ loggedInNom }}</p>
              <p class="mobile-maj">{{ maj }}</p>
            </div>
            <ul class="mobile-menu-list">
              <li v-if="loggedInRole !== 'reception' && loggedInRole !== 'approvisionnement' && loggedInRole !== 'comptabilite'"><RouterLink to="/" @click="closeMobileMenu"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-check-fill" viewBox="0 0 16 16">
                <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm1.354 4.354-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708.708z"/>
              </svg>Articles</RouterLink></li>
              <li v-if="loggedInRole === 'achats' || loggedInRole === 'admin' || loggedInRole === 'production' || loggedInRole === 'be' || loggedInRole=='gestion'"><RouterLink to="/affaires" @click="closeMobileMenu"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-bar-graph-fill" viewBox="0 0 16 16">
                <path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-2 11.5v-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm-2.5.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1zm-3 0a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-1z"/>
              </svg>Affaires</RouterLink></li>
              <li v-if="loggedInRole === 'achats' || loggedInRole === 'admin' || loggedInRole === 'production' || loggedInRole === 'be' || loggedInRole=='gestion'"><RouterLink to="/evol-affaires" @click="closeMobileMenu"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-bar-graph-fill" viewBox="0 0 16 16">
                <path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-2 11.5v-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm-2.5.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1zm-3 0a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-1z"/>
              </svg>Évol affaires</RouterLink></li>
              <li v-if="loggedInRole === 'achats' || loggedInRole === 'admin' || loggedInRole === 'gestion'"><RouterLink to="/demandes" @click="closeMobileMenu"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chat-quote-fill" viewBox="0 0 16 16">
                <path d="M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7zM7.194 6.766a1.688 1.688 0 0 0-.227-.272 1.467 1.467 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 5.734 6C4.776 6 4 6.746 4 7.667c0 .92.776 1.666 1.734 1.666.343 0 .662-.095.931-.26-.137.389-.39.804-.81 1.22a.405.405 0 0 0 .011.59c.173.16.447.155.614-.01 1.334-1.329 1.37-2.758.941-3.706a2.461 2.461 0 0 0-.227-.4zM11 9.073c-.136.389-.39.804-.81 1.22a.405.405 0 0 0 .012.59c.172.16.446.155.613-.01 1.334-1.329 1.37-2.758.942-3.706a2.466 2.466 0 0 0-.228-.4 1.686 1.686 0 0 0-.227-.273 1.466 1.466 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 10.07 6c-.957 0-1.734.746-1.734 1.667 0 .92.777 1.666 1.734 1.666.343 0 .662-.095.931-.26z"/>
              </svg>Demandes</RouterLink></li>
              <li v-if="loggedInRole === 'achats' || loggedInRole === 'admin' || loggedInRole=='gestion'"><RouterLink to="/achats" @click="closeMobileMenu"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chat-quote-fill" viewBox="0 0 16 16">
                <path d="M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7zM7.194 6.766a1.688 1.688 0 0 0-.227-.272 1.467 1.467 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 5.734 6C4.776 6 4 6.746 4 7.667c0 .92.776 1.666 1.734 1.666.343 0 .662-.095.931-.26-.137.389-.39.804-.81 1.22a.405.405 0 0 0 .011.59c.173.16.447.155.614-.01 1.334-1.329 1.37-2.758.941-3.706a2.461 2.461 0 0 0-.227-.4zM11 9.073c-.136.389-.39.804-.81 1.22a.405.405 0 0 0 .012.59c.172.16.446.155.613-.01 1.334-1.329 1.37-2.758.942-3.706a2.466 2.466 0 0 0-.228-.4 1.686 1.686 0 0 0-.227-.273 1.466 1.466 0 0 0-.469-.324l-.008-.004A1.785 1.785 0 0 0 10.07 6c-.957 0-1.734.746-1.734 1.667 0 .92.777 1.666 1.734 1.666.343 0 .662-.095.931-.26z"/>
              </svg>Achats</RouterLink></li>
              <li v-if="loggedInRole=='admin'"><RouterLink to="/utilisateurs" @click="closeMobileMenu"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-people-fill" viewBox="0 0 16 16">
                <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216ZM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/>
              </svg>Utilisateurs</RouterLink></li>
              <li v-if="loggedInRole=='admin' || loggedInRole=='gestion'"><RouterLink to="/recap" @click="closeMobileMenu"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-people-fill" viewBox="0 0 16 16">
                <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216ZM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/>
              </svg>Recaps</RouterLink></li>
              <li v-if="loggedInRole=='admin' || loggedInRole=='gestion' || loggedInRole === 'production'"><RouterLink to="/inventaire" @click="closeMobileMenu"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-people-fill" viewBox="0 0 16 16">
                <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216ZM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/>
              </svg>Inventaire</RouterLink></li>
              <li v-if="loggedInRole === 'production'"><RouterLink to="/mes-heures" @click="closeMobileMenu"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clock-history" viewBox="0 0 16 16"><path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z"/><path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z"/><path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z"/></svg>Heures</RouterLink></li>
              <li v-if="loggedInRole === 'admin' || loggedInRole === 'production' || loggedInRole === 'be' || loggedInRole === 'gestion' || loggedInRole === 'comptabilite'"><RouterLink to="/scan-documents" @click="closeMobileMenu"><svg fill="#ffffff" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M8,2A1,1,0,0,1,8,4H4V8A1,1,0,0,1,2,8V3A1,1,0,0,1,3,2ZM8,20H4V16a1,1,0,0,0-2,0v5a1,1,0,0,0,1,1H8a1,1,0,0,0,0-2Zm13-5a1,1,0,0,0-1,1v4H16a1,1,0,0,0,0,2h5a1,1,0,0,0,1-1V16A1,1,0,0,0,21,15Zm0-6a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H16a1,1,0,0,0,0,2h4V8A1,1,0,0,0,21,9Zm1,2H2a1,1,0,0,0,0,2H22a1,1,0,0,0,0-2Z"></path></g></svg>GED</RouterLink></li>
              <li v-if="loggedInRole=='admin'"><RouterLink to="/admin" @click="closeMobileMenu"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-people-fill" viewBox="0 0 16 16">
                <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216ZM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/>
              </svg>Outils</RouterLink></li>
              <li class="mobile-deco" @click="logout()"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-arrow-left" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0z"/>
                <path fill-rule="evenodd" d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708z"/>
              </svg>Déconnexion</li>
            </ul>
          </div>
        </div>
      
    
    </div>
    <div v-else-if="isPasswordRecoveryRoute" class="connexion container">

      <!-- Optionnel : overlay sombre pour améliorer la lisibilité -->
      <h1>Mot de passe oublié</h1>
      <form @submit.prevent="forgot">
        <label>
          Email:
          <input type="text" v-model="email">
        </label>
        <button type="submit">Envoyer</button>
        <div v-if="mailWrong" class="alert alert-danger" role="alert">
          {{ mailWrong }}
        </div>
        <div v-if="mailOk" class="alert alert-success" role="alert">
          {{ mailOk }}
        </div>
      </form>
      <RouterLink class="d-inline-block mt-3 forgot" to="/">Me connecter</RouterLink>
    </div>
    <div v-else-if="isPasswordRecoveryRoute2" class="connexion container">

      <h1>Changer mon mot de passe</h1>
      <form @submit.prevent="changeMdp">
        <label>
          Mot de passe:
          <input type="password" v-model="password">
        </label>
        <label>
          Confirmation du mot de passe:
          <input type="password" v-model="passwordConfirm">
        </label>
        <button type="submit">Envoyer</button>
        <div v-if="mailWrong" class="alert alert-danger" role="alert">
          {{ mailWrong }}
        </div>
        <div v-if="mailOk" class="alert alert-success" role="alert">
          {{ mailOk }}
        </div>
      </form>
      <RouterLink class="d-inline-block mt-3 forgot" to="/">Me connecter</RouterLink>
    </div>
    <div v-else class="connexion">

      <div class="container">
        <div class="row">
            <img alt="Simef logo" class="logo-collab" src="@/assets/logo-footer.png" />

            <div class="description">
              <p>SIMEF Industrie a développé un outil en ligne pour accompagner la gestion des stocks des matériels confiés et le suivi des commandes
                en cours. Cet espace client Digital collaboratif est en lien direct avec la GPAO de l’entreprise.</p>
              <p>L’activation de votre espace est à demander en amont auprès de votre contact commercial.</p>
              <p>Outil : <strong>DIGITAL Collaboration par SIMEF Industrie.</strong></p>
            </div>
         
        </div>
    
        <form @submit.prevent="login">
          <label>
            Email:
            <input type="text" v-model="email">
          </label>
          <label>
            Mot de passe:
            <input type="password" v-model="password">
          </label>
          <button type="submit">Connexion</button>
          <div v-if="incorrectMdp" class="alert alert-danger" role="alert">
            {{ incorrectMdp }}
          </div>
        </form>
    
        <RouterLink class="d-inline-block mt-3 forgot" to="/mot-de-passe-oublie">Mot de passe oublié ?</RouterLink>
      </div>

    </div>
    <!-- Loader -->
    <div v-if="isLoading" class="loader">
      <div id="loading"></div>
    </div>
  
</template>

<script>
import axios from '@/components/axiosConfig.js'
import VueCookies from 'vue-cookies'

export default {
  data() {
    return {
      email: '',
      password: '',
      passwordConfirm: '',
      loggedInEmail: null,
      loggedInRole: null,
      loggedInMagasin: null,
      loggedInDate: null,
      loggedInPrenom: null,
      loggedInNom: null,
      incorrectMdp: '',
      isLoading: false,
      mailWrong: '',
      mailOk: '',
      role: '',
      maj: null,
      timer: null,
      token: '',
      isMobileMenuOpen: false
    }
  },
  mounted() {
    this.fetchExecutionTime();
    this.timer = setInterval(this.fetchExecutionTime, 60000); // Fetch every minute
    this.token = this.getParameterByName('token');
    // Check if the current URL has a token parameter
    if (this.token) {
      // This is a password reset URL, do not perform logout or the other Axios request
      return;
    } else {
     
      axios.get('https://www.simef.fr/espace-client/api/testIdentification.php')
      .then(response => {
        console.log(response);
      })
      .catch(error => {
        console.error(error);
        this.logout();
      });
    }
   
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
  created() {

    const email = VueCookies.get('email')
    if (email) {
      this.loggedInEmail = email
    }
    const role = VueCookies.get('role')
    if (role) {
      this.loggedInRole = role
    }
    const date = VueCookies.get('date')
    if (date) {
      this.loggedInDate = date
    }
    const prenom = VueCookies.get('prenom')
    if (prenom) {
      this.loggedInPrenom = prenom
    }
    const nom = VueCookies.get('nom')
    if (nom) {
      this.loggedInNom = nom
    }


    

  },
  computed: {
    isPasswordRecoveryRoute() {
      return this.$route.path === '/mot-de-passe-oublie'; // Replace with your actual password recovery route
    },
    isPasswordRecoveryRoute2() {
      return this.$route.path === '/reinitialiser-mot-de-passe'; // Replace with your actual password recovery route
    }
  },
  methods: {
    login() {
      axios.post('https://www.simef.fr/espace-client/api/connexion.php', {
        email: this.email,
        password: this.password
      })
      .then(response => {

        if (response.data.success == true) {
          VueCookies.set('session', response.data.sessionId)
          VueCookies.set('nom', response.data.nom)
          VueCookies.set('prenom', response.data.prenom)
          VueCookies.set('email', response.data.email)
          VueCookies.set('role', response.data.role)
          VueCookies.set('magasin', response.data.magasin)
          VueCookies.set('token', response.data.token, null, '/espace-client/')
          this.loggedInEmail = response.data.email
          this.loggedInRole = response.data.role
          this.loggedInMagasin = response.data.magasin
          this.loggedInNom = response.data.nom
          this.loggedInPrenom = response.data.prenom

          axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
          // La comptabilité n'a accès qu'à la GED : on l'y envoie directement
          if (response.data.role === 'comptabilite') {
            this.$router.push('/scan-documents/');
          } else {
            this.$router.push('/?page=1&searchTerm=&selectedMag=&selectedFourn=&showOnlyAvailable=&sortColumn=&sortDirection=');
          }

          console.log(response.data)
          this.email='';
          this.password='';

        } else {
          // afficher un message d'erreur
          this.incorrectMdp = response.data.message;
        }


      })
      .catch(error => {
        console.log(error);
      })
    },
  
    fetchExecutionTime() {
      axios.get('https://www.simef.fr/espace-client/api/executionTime.php')
      .then(response => {
        this.maj = response.data.execution_time;
      })
      .catch(error => {
        console.log(error);
      });
    },
    forgot() {
      this.isLoading = true; // Show loader
      axios.post('https://www.simef.fr/espace-client/api/forgot.php', {
        email: this.email,
      })
      .then(response => {
        this.mailOk = response.data.success;
        this.mailWrong = response.data.error;
        this.email = '';
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.isLoading = false; // Hide loader
      });
    },
    changeMdp() {
      axios.post('https://www.simef.fr/espace-client/api/changeMdp.php', {
        password: this.password,
        passwordConfirm: this.passwordConfirm,
        token: this.token
      })
      .then(response => {
        this.mailOk = response.data.success;
        this.mailWrong = response.data.error;
        this.password = '';
        this.passwordConfirm = '';
      })
      .catch(error => {
        console.log(error);
      });
    },
    getParameterByName(name, url = window.location.href) {
      name = name.replace(/[\]]/g, '$&');
      const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
      const results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },

    logout() {
      VueCookies.remove('session')
      VueCookies.remove('email')
      VueCookies.remove('role')
      VueCookies.remove('magasin')
      VueCookies.remove('nom')
      VueCookies.remove('prenom')
      VueCookies.remove('token');
      this.loggedInEmail = null
      this.loggedInRole = null
      this.loggedInPrenom = null
      this.loggedInNom = null
      this.loggedInMagasin = null
      this.redirectToLogin(); // Redirige vers la page de connexion après la déconnexion.

    },
    redirectToLogin() {
      this.$router.push('/'); // Remplacez '/connexion' par le chemin de votre page de connexion.
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
    },
 
  }, 
}
</script>

<style lang="scss">

$primary: #2b358d;
.description {
  text-align: left;
}
h2 {
  font-size: 1.5rem!important;
}
.forgot {
  text-decoration: underline!important;
  font-size: 0.9rem;
  color: $primary;
}
.sous-menu {
  position: relative;
  height: 150px;
  z-index: 1;
  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
  .links {
    position: absolute;
    top: 15px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    a {
      background: #fff;
      padding: 15px 30px;
      font-weight: 600;
      color: #2b358d!important;
      &::before {
        display: none;
      }
    }
  }
}
a {
  text-decoration: none!important;
  color: #2b358d;
}
.preHeader {
  background: #2b358d;
  padding: 20px 0px;
}
button {
  padding: 8px 25px!important;
  font-weight: 500;
  background: #2b358d!important;
}
.maj {
  text-align: right;
  font-size: 0.85rem;
  font-style: italic;
  margin-bottom: 5px;
  font-weight: 500;
  p {
    margin-bottom: 5px;
  }
  @media screen and (max-width:992px) {
    display: none;
  }
}
.pagination {
  display: inherit!important;
  width: unset!important;
  margin-top: 0px!important;
}
form {
  input {
    background: #fff!important;
    color: #333!important;
  }
}
.links {
  a {
    background: #2b358d;
    color: #fff!important;
    padding: 10px 20px;
  }
}
select, input {
  background: #fff;
  color: #333 !important;
  font-weight: 500;
  border: 1px solid #ccc!important;
  padding: 6px 10px!important;
  &::placeholder {
    color: #333;
    padding: 0px 5px;
  }
  &:focus-visible {
    outline: unset!important;
    border-color: unset!important;
  }
  @media screen and (max-width:992px) {
    width: 100%;
  }
}
label {
  @media screen and (max-width:992px) {
    width: 100%;
  }
}
.pagination {
  select {
    @media screen and (max-width:992px) {
      width: inherit;
    }
  }
}
p {
  font-weight: 500;
}
h1 {
  margin-bottom:30px!important;
  padding: 0px 50px;
  margin-top: 35px!important;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  @media screen and (max-width:992px) {
    padding-bottom: 125px;
    margin-top: 0px;
  }
}
header {
  background: #1d1d20;
  color: #fff;
  position: relative;
  z-index: 2;
}
@media screen and (max-width:992px) {
  header {
    display: flex;
    align-items: center;
    justify-content: center;
    position: sticky;
    top: 0;
  }
  .logo {
    margin-bottom: 0px!important;
  }
}
.menu {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
 
}

.mobile-menu-toggle {
  display: none; // Masqué par défaut sur desktop
}
nav {
  svg {
    display: none;
  }
  ul {
    display: flex;
    list-style: none;
    flex-wrap: wrap;
    justify-content: center;
    padding: 0px;
    margin: 0px;
    gap: 30px;
    li {
    }
  }
  a {

    color: #fff;
    text-decoration: none;
    font-weight: 600;
    font-size: 0.9rem !important;
    text-transform: uppercase;
    &.router-link-exact-active {
      color: #fff;
      font-weight: 800!important;
      text-decoration: underline!important;
      text-decoration-color: #0083df!important;
      text-decoration-thickness: 5px!important;
      text-underline-offset: 5px!important;
    }
    &:hover {
      color: #e2e2e2;
    }
  }
  .deco {
   color: #fff;
    text-decoration: none;
    font-weight: 500;
    font-size: 0.95rem!important;
    text-transform: uppercase;
        display: flex;
    align-items: center;
  }
  .deco svg {
    display: inherit;
        height: 22px;
    width: 22px;
  }
}

.logo-footer {
  width: 100%;
}

.logo-collab {
  width: 100%;
  animation: breathe 3s infinite; /* Utilisez l'animation "breathe" pendant 3 secondes, en boucle */
}

/* Définissez l'animation "breathe" */
@keyframes breathe {
  0% {
    opacity: 1; /* Opacité maximale au début */
    transform: scale(1); /* Taille normale au début */
  }
  50% {
    opacity: 0.8; /* Opacité réduite à mi-chemin de l'animation */
    transform: scale(1.04); /* Taille agrandie à mi-chemin de l'animation */
  }
  100% {
    opacity: 1; /* Opacité maximale à la fin */
    transform: scale(1); /* Taille normale à la fin */
  }
}
.mobile-menu-overlay {
  display: none;
}
@media screen and (max-width:992px) {
  nav {
    display: none; // Cache le menu desktop sur mobile
  }
  
  .mobile-menu-toggle {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 30px;
    height: 20px;
    cursor: pointer;
    z-index: 1000;
    
    span {
      display: block;
      height: 2px;
      width: 100%;
      background-color: #fff;
      border-radius: 3px;
      transition: all 0.3s ease;
    }
    
    &:hover span {
      background-color: #e2e2e2;
    }
  }
  
  .mobile-menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 9999;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    display: inherit;
    &.active {
      opacity: 1;
      visibility: visible;
    }
  }
  
  .mobile-menu-content {
    position: absolute;
    top: 0;
    right: 0;
    width: 80%;
    max-width: 400px;
    height: 100%;
    background-color: #2b358d;
    transform: translateX(100%);
    transition: transform 0.3s ease;
    overflow-y: auto;
    
    .mobile-menu-overlay.active & {
      transform: translateX(0);
    }
  }
  
  .mobile-menu-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    
    h3 {
      color: #fff;
      margin: 0;
      font-size: 1.5rem;
      font-weight: 600;
    }
    
    .close-menu {
      background: none;
      border: none;
      color: #fff;
      font-size: 1.5rem;
      cursor: pointer;
      padding: 0;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 0px!important;
      
      &:hover {
        background-color: rgba(255, 255, 255, 0.1);
      }
    }
  }
  
  .mobile-menu-user {
    padding: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    
    p {
      color: #fff;
      margin: 0 0 5px 0;
      font-size: 1rem;
      font-weight: 500;
    }
    
    .mobile-maj {
      font-size: 0.85rem;
      font-style: italic;
      opacity: 0.8;
    }
  }
  
  .mobile-menu-list {
    list-style: none;
    padding: 0;
    margin: 0;
    .mobile-deco {
        display: flex;
        align-items: center;
        padding: 15px 20px;
        color: #fff;
        text-decoration: none;
        font-size: 1rem;
        font-weight: 500;
        transition: background-color 0.2s ease;
        cursor: pointer;
        svg {
          margin-right: 15px;
          width: 20px;
          height: 20px;
          flex-shrink: 0;
        }
        
        &:hover {
          background-color: rgba(255, 255, 255, 0.1);
        }
        
        &.router-link-active {
          background-color: rgba(255, 255, 255, 0.2);
          font-weight: 600;
        }
      }
    li {
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      
      a, .mobile-deco {
        display: flex;
        align-items: center;
        padding: 15px 20px;
        color: #fff;
        text-decoration: none;
        font-size: 1rem;
        font-weight: 500;
        transition: background-color 0.2s ease;
        
        svg {
          margin-right: 15px;
          width: 20px;
          height: 20px;
          flex-shrink: 0;
        }
        
        &:hover {
          background-color: rgba(255, 255, 255, 0.1);
        }
        
        &.router-link-active {
          background-color: rgba(255, 255, 255, 0.2);
          font-weight: 600;
        }
      }
      
      .mobile-deco {
        cursor: pointer;
        width: 100%;
        border: none;
        background: none;
        text-align: left;
      }
    }
  }
}









button, .links a, .actionsAdmin a {
  display: inline-block;
  color: #fff;
  border: none;
  transition: background-color 0.3s ease, transform 0.2s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  z-index: 1;
  font-weight: 500;
}

button::before, .links a:before, .actionsAdmin a:before {
  content: "";
  position: absolute;
  top: -100%;
  left: -50%;
  width: 200%;
  height: 200%;
  background-color: rgba(9, 16, 34, 0.25);
  transform: translate(-50%, -50%);
  transition: all 0.4s ease;
  z-index: -1;
}

button::after, .links a::after, .actionsAdmin a:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.2) 75%, transparent 75%, transparent);
  background-size: 30px 30px;
  opacity: 0;
  transition: opacity 0.4s ease;
}

button:hover, .links a:hover, .actionsAdmin a:hover {
  transform: scale(1.1) rotate(2deg);
  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.3);
  backface-visibility: hidden; /* Ajout de cette ligne */
}

button:hover::before, .links a:hover::before, .actionsAdmin a:hover::before {
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%) rotate(42deg);
}

button:hover::after, .links a:hover::after, .actionsAdmin a:hover::after {
  opacity: 0.5;
}

button:active, .links a:active, .actionsAdmin a:active {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
  transform: translateY(2px);
}

input[type="text"], input, select {
  border: 0!important;
  border-bottom: 1px solid #000!important;
}

.admin, .inscription, .connexion, .solder, .inventaireListe, .actions, .code, .com {
  input[type="text"], input, select { 
    border: 0;
  }
  
}
input[type="file"] {
  width: 0.1px!important;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
input[type="file"] + label {
  font-size: 1rem;
  font-weight: 700;
  color: white;
  background-color: #1d1d20;
  display: inline-block;
  padding: 6px 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    margin-right: 8px;
    height: 20px;
    width: 20px;
  }
}

input[type="file"]:focus + label,
input[type="file"] + label:hover {
    background-color: #2b358d;
}

input[type="file"] + label {
  cursor: pointer; /* "hand" cursor */
}

.connexion {
  padding-top: 50px;
  .forgot {
    color: #000;
    font-size: 1.2rem;
    font-weight: 600;
}
  .row {
    flex-direction: column;
    .description {
      max-width: 50%;
      margin: auto;
      text-align: center;
      @media screen and (max-width:1199px) {
        max-width: 100%;
      }
      p {
        color: #000;
        font-size: 1.15rem;
        margin-top: 20px;
        font-weight: 600;
        line-height: 1.3;
      }
  }
  }
  .logo-collab {
    width: 40%;
    margin: auto;
    margin-block: 25px;
    @media screen and (max-width:992px) {
      width: 75%;
    }
  }
  h1 {
    color: #000;
  }
  button {
    background-color: #2f3db1 !important;
    color: #fff !important;
    display: inline-block !important;
    text-transform: uppercase !important;
    font-style: italic !important;
    font-weight: 600 !important;
    padding: 1rem 2rem !important;
    border: 0px !important;
    border-radius: 15px !important;
    letter-spacing: 1px !important;
    transition: .4s ease-in-out;
    font-size: 1rem !important;
    font-family: "Montserrat" !important;
  }
  form {
    background: none!important;
    padding: 0!important;
    max-width: 50%;
    margin: auto;
    @media screen and (max-width:1199px) {
      max-width: 100%;
    }
    input {
      background: unset !important;
      border: solid 2px rgba(0, 0, 0, .1) !important;
      padding: 24px !important;
      font-weight: 600 !important;
      color: #2e2e2f !important;
      font-family: "Montserrat" !important;
    }
    label {
      color: #000;
      font-size: 1.2rem;
    }
  }
  .affaires.folder-header {
      text-transform: uppercase;
  }
}
@media (min-width: 1400px) {
    .container, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl {
        max-width: 1500px!important;
    }
}
.pagination-pages {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin: 0 !important;
    @media screen and (max-width:992px) {
      width: 100%;
    }
    span {
      cursor: pointer;
      margin: 3px 4px;
      font-size: 0.9rem;
      font-weight: 500;
    }
    .active {
      color: $primary;
      font-weight: 900;
    }
    select {
      color: #333!important;
      border: 0px;
      padding: 12px 15px;
      margin-right: 10px;
    }
  }
  .top-bar {
    margin-top: 10px;
    gap: 8px;
  }
  .card-actions {
        display: flex;
        gap: 12px;
        a {
          color: #2b358d;
          background: #fff;
          border-radius: 0px;
          padding: 5px 10px;
          display: flex;
          align-items: center;
          transition: background 0.2s;
          font-size: 0.9rem;
          font-weight: 600;
          gap: 5px;
          &:hover {
            background: #dbe9fa;
          }
          svg {
            margin: 0;
            height: 20px;
            width: 20px;
            margin-right: 0px!important;
            path {
              fill: #2b358d;
            }
          }
        }
      }
      .sort-btn {
        &:hover {
          color: #fff!important;
        }
      }
      @media screen and (max-width:992px) {
        button {
          padding: 5px 12px !important;
        }
        .actionsAdmin {
          a {
            padding: 5px 12px !important;
          }
        }
        
      }

      .hello {
          overflow-x: hidden!important;
      }
      .pagination{
          max-width: 100% !important;
      }
    @media screen and (max-width: 992px) {
        input[type="checkbox"] {
            width: initial;
        }
    }
</style>